export const mapBookings = (response) => {
  if (response && response.data && response.data.success === true) {
    const rows = Array.isArray(response.data.data)
      ? response.data.data.map((b) => ({
          id: b.id || null,
          slack: b.slack || null,
          event_code: b.event_code || null,
          event_type: b.event_type || null,
          start_date: b.start_date || null,
          end_date: b.end_date || null,
          name: b.name || null,
          email: b.email || null,
          phone: b.phone || null,
          description: b.description || null,
          no_of_persons: b.no_of_persons || null,
          created_at: b.created_at || null,
          updated_at: b.updated_at || null,
          created_by: b.created_by || null,
          updated_by: b.updated_by || null,
          store: b.store ? {
            name: b.store?.name || null
          } : null
        }))
      : []
    return {
      success: true,
      total: response.data.total || rows.length,
      data: rows
    }
  }
  return {
    success: false,
    message: response?.data?.message || 'Failed to fetch bookings',
    data: []
  }
}

export const mapBookingDetail = (response) => {
  // console.log('mapBookingDetail called with response:', response)
  if (response && response.data && response.data.success === true) {
    const b = response.data.data || {}
    // console.log('Booking data:', b)
    const detail = {
      id: b.id || null,
      slack: b.slack || null,
      event_code: b.event_code || null,
      event_type: b.event_type || null,
      start_date: b.start_date || null,
      end_date: b.end_date || null,
      name: b.name || '',
      email: b.email || '',
      phone: b.phone || '',
      description: b.description || '',
      no_of_persons: b.no_of_persons || '0',
      created_at: b.created_at || b.createdAt || null,
      updated_at: b.updated_at || b.updatedAt || null,
      created_by: b.created_by || null,
      updated_by: b.updated_by || null,
      store: b.store || null
    }
    console.log('Mapped detail:', detail)
    return { success: true, data: detail }
  }
  console.log(
    'mapBookingDetail failed:',
    response?.data?.message || 'Failed to fetch booking'
  )
  return {
    success: false,
    message: response?.data?.message || 'Failed to fetch booking'
  }
}
